module.exports = __webpack_public_path__ + "img/screen-write-es.f3317573.png";